"use client";

import SearchTemplate from "@/modules/home/templates/search";
import { ApolloProvider } from "@apollo/client";
import { APIProvider } from "@vis.gl/react-google-maps";
import client from "@/lib/api/apollo-client";
import dynamic from "next/dynamic";
import MediaListTemplate from "@/modules/home/templates/media-list";
import { environments } from "@/lib/config";
import { useUser } from "@/stores/user";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { isEmptyObject } from "@/lib/utils";

const Maps = dynamic(() => import("@/modules/home/templates/maps"), {
  ssr: false,
});

export default function MainLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const router = useRouter();
  const { userInfo } = useUser();
  const user = userInfo?.user;
  const isDeleted = user?.is_deleted ?? false;
  const isActive = user?.is_active ?? false;
  const isTempPassword = user?.is_temporary_password ?? false;
  const isAccountSuspended = !isActive || isDeleted;
  const hasTemporaryPassword = isTempPassword;
  useEffect(() => {
    if (isEmptyObject(userInfo?.user)) return;
    if (isAccountSuspended) {
      router.replace("/account-suspended");
    }
    if (hasTemporaryPassword) {
      router.replace("/account-temppassword");
    }
  }, [userInfo?.user]);

  return (
    <ApolloProvider client={client}>
      <APIProvider
        apiKey={environments.googleMapAPIKey as string}
        region="kr"
        version="weekly"
        libraries={["geocoding", "visualization"]}
        // onLoad={() => console.log("Maps API has loaded.")}
      >
        <div className="w-full min-h-[calc(100vh-var(--header-height))] pt-[var(--header-height)]">
          {children}
          <Maps />
          <SearchTemplate />
          <MediaListTemplate />
        </div>
      </APIProvider>
    </ApolloProvider>
  );
}
